import AppStateService from '@ajs/services/AppStateService';
import { inject, Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { LinkService } from '@app/core/services/link.service';
import { LocalStorageService } from '@app/core/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class TransformersRoutingService {
    static readonly TRANSFORMERS_NEW_LOCAL_STORAGE_KEY_PREFIX: string = 'new-transformers';

    private get localStorageKey(): string {
        return `${TransformersRoutingService.TRANSFORMERS_NEW_LOCAL_STORAGE_KEY_PREFIX}-${this.appStateService.getUserId()}`;
    }

    private readonly appStateService: AppStateService = inject(AppStateService);
    private readonly linkService: LinkService = inject(LinkService);
    private readonly localStorageService: LocalStorageService = inject(LocalStorageService);
    private readonly router: Router = inject(Router);

    switchToLegacyTransformers(field?: string): void {
        this.localStorageService.setItem(this.localStorageKey, 'legacy');
        const link = this.linkService.transformersLinkWithField(field);
        void this.router.navigate(link);
    }

    /**
     * Prefer this over UI-Router `$state.go('app.transformers-new')` from AngularJS: empty-template
     * hybrid states sync poorly with Angular's router-outlet unless Angular Router runs the navigation.
     *
     * @param field optional field name for `?field=` (matches legacy deep links)
     * @param persistNewTransformersPreference when true, sets localStorage preference to "current"
     */
    switchToNewTransformers(
        field?: string | null,
        persistNewTransformersPreference: boolean = true
    ): void {
        if (persistNewTransformersPreference) {
            this.localStorageService.setItem(this.localStorageKey, 'current');
        }

        const extras: NavigationExtras = {
            ...(field ? { queryParams: { field } } : {})
        };
        void this.router.navigate(this.linkService.transformersNewLink, extras);
    }
}
